module.exports = __webpack_public_path__ + "img/paymob.c71a3b72.png";